"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var shared_1 = require("@formily/shared");
var useFormSpy_1 = require("../hooks/useFormSpy");
exports.FormSpy = function (props) {
    if (shared_1.isFn(props.children)) {
        return props.children(useFormSpy_1.useFormSpy(props)) || react_1.default.createElement(react_1.Fragment, null);
    }
    else {
        return props.children || react_1.default.createElement(react_1.Fragment, null);
    }
};
exports.FormSpy.displayName = 'ReactInternalFormSpy';
exports.FormSpy.defaultProps = {
    selector: "*",
    reducer: function (state, action) {
        return __assign(__assign({}, state), action.payload);
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/components/FormSpy.js
// module id = 1025
// module chunks = 0